export default function MagnifyingGlassIcon() {
  return (
    <>
      <circle
        cx='11.9224'
        cy='12.0044'
        r='5.59426'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8047 16.1836L17.998 18.3712'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
